/**
 * LandingFeatures — Feature-Grid der öffentlichen Landingpage (W4.2)
 *
 * Zeigt mindestens 3 Feature-Cards mit Icon, Titel, Kurztext.
 * Icons: inline SVG, angelehnt an icons.js des Prototyps.
 */
import { useTranslation } from 'react-i18next'

type FeatureKey =
  | 'hotspotTracking'
  | 'walletManagement'
  | 'premiumAnalytics'
  | 'monthlyReports'
  | 'realtimeData'
  | 'customerApi'

interface FeatureCard {
  icon: React.ReactNode
  key: FeatureKey
}

const featureCards: FeatureCard[] = [
  {
    icon: (
      <svg viewBox="0 0 20 20" width={24} height={24} fill="none" stroke="currentColor" strokeWidth={1.5} aria-hidden="true">
        <circle cx="10" cy="10" r="3" />
        <path d="M10 2v2M10 16v2M2 10h2M16 10h2M4.22 4.22l1.42 1.42M14.36 14.36l1.42 1.42M4.22 15.78l1.42-1.42M14.36 5.64l1.42-1.42" strokeLinecap="round" />
      </svg>
    ),
    key: 'hotspotTracking',
  },
  {
    icon: (
      <svg viewBox="0 0 20 20" width={24} height={24} fill="none" stroke="currentColor" strokeWidth={1.5} aria-hidden="true">
        <rect x="3" y="6" width="14" height="10" rx="2" />
        <path d="M7 6V5a3 3 0 0 1 6 0v1" strokeLinecap="round" />
        <circle cx="10" cy="11" r="1.5" />
      </svg>
    ),
    key: 'walletManagement',
  },
  {
    icon: (
      <svg viewBox="0 0 20 20" width={24} height={24} fill="none" stroke="currentColor" strokeWidth={1.5} aria-hidden="true">
        <path d="M3 13l4-4 3 3 4-5 3 2" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="3" y="3" width="14" height="14" rx="2" />
      </svg>
    ),
    key: 'premiumAnalytics',
  },
  {
    icon: (
      <svg viewBox="0 0 20 20" width={24} height={24} fill="none" stroke="currentColor" strokeWidth={1.5} aria-hidden="true">
        <path d="M4 4h12v2H4zM4 9h8v2H4zM4 14h5v2H4z" />
        <path d="M15 13l2 2-2 2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    key: 'monthlyReports',
  },
  {
    icon: (
      <svg viewBox="0 0 20 20" width={24} height={24} fill="none" stroke="currentColor" strokeWidth={1.5} aria-hidden="true">
        <circle cx="10" cy="10" r="7" />
        <path d="M10 6v4l2.5 2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    key: 'realtimeData',
  },
  {
    icon: (
      <svg viewBox="0 0 20 20" width={24} height={24} fill="none" stroke="currentColor" strokeWidth={1.5} aria-hidden="true">
        <path d="M10 2l2.4 4.8 5.6.8-4 3.9.9 5.5L10 14.5l-4.9 2.5.9-5.5L2 7.6l5.6-.8z" strokeLinejoin="round" />
      </svg>
    ),
    key: 'customerApi',
  },
]

export function LandingFeatures() {
  const { t } = useTranslation('landing')

  return (
    <section className="landing-features" data-testid="landing-features">
      <div className="landing-section-header">
        <h2>{t('features.sectionTitle')}</h2>
        <p>{t('features.sectionSub')}</p>
      </div>

      <div className="landing-features__grid">
        {featureCards.map((f) => (
          <div key={f.key} className="landing-feature-card card" data-testid="feature-card">
            <div className="landing-feature-card__icon">{f.icon}</div>
            <h3 className="landing-feature-card__title">{t(`features.${f.key}.title`)}</h3>
            <p className="landing-feature-card__desc">{t(`features.${f.key}.description`)}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
